import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxConnectionStatusService } from './services/ngx-connection-status.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ngx-connection-status',
  template: `<div class="connection-status_container">
  <div *ngIf="isOnline && !fresh" class="connection-status_online">
    <span><i class="fas fa-check-circle"></i> You have been reconnected</span>
  </div>
  <div *ngIf="!isOnline" class="connection-status_offline">
    <span><i class="fas fa-exclamation-circle"></i> You are disconnected</span>
  </div>
</div>
`,
  styles: [`.connection-status_container{width:100%;clear:both;position:relative;color:#fff;transition:background-color linear .3s;z-index:2000}.connection-status_offline,.connection-status_online{padding:.5rem}.connection-status_online{background-color:#32e259;-webkit-animation-name:reconnected;animation-name:reconnected;-webkit-animation-delay:3s;animation-delay:3s;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.connection-status_offline{background-color:#e23237}@-webkit-keyframes reconnected{from{opacity:1}to{opacity:0;display:none}}@keyframes reconnected{from{opacity:1}to{opacity:0;display:none}}.bl,.br,.tl,.tr{position:fixed;width:auto}.bl>div,.br>div,.tl>div,.tr>div{border-radius:2px;box-shadow:0 3px 7px 1px rgba(0,0,0,.3)}.tl{top:10px;left:10px}.tr{top:10px;right:10px}.bl{bottom:10px;left:10px}.br{bottom:10px;right:10px}`]
})
export class NgxConnectionStatusComponent implements OnInit, OnDestroy {

  isOnline: boolean =  true;
  fresh: boolean = true;
  subscription: Subscription;

  constructor(private cs: NgxConnectionStatusService) { }

  ngOnInit() {
    this.subscription = this.cs.statusHook().subscribe(isOnline => {
      if (isOnline) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
        this.fresh = false;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
